var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoondreamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_22980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6128 23.9991C18.9013 23.9991 23.9991 18.9013 23.9991 12.6128C23.9991 6.32436 18.9013 1.22656 12.6128 1.22656C6.32436 1.22656 1.22656 6.32436 1.22656 12.6128C1.22656 18.9013 6.32436 23.9991 12.6128 23.9991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 23.0256C18.3637 23.0256 23.0256 18.3637 23.0256 12.6129C23.0256 6.86212 18.3637 2.2002 12.6129 2.2002C6.86212 2.2002 2.2002 6.86212 2.2002 12.6129C2.2002 18.3637 6.86212 23.0256 12.6129 23.0256Z",
    fill: "#BDC9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 23.0256C18.3637 23.0256 23.0256 18.3637 23.0256 12.6129C23.0256 6.86212 18.3637 2.2002 12.6129 2.2002C6.86212 2.2002 2.2002 6.86212 2.2002 12.6129C2.2002 18.3637 6.86212 23.0256 12.6129 23.0256Z",
    fill: "#BDC9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 23.0256C18.3637 23.0256 23.0256 18.3637 23.0256 12.6129C23.0256 6.86212 18.3637 2.2002 12.6129 2.2002C6.86212 2.2002 2.2002 6.86212 2.2002 12.6129C2.2002 18.3637 6.86212 23.0256 12.6129 23.0256Z",
    fill: "#BDC9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7353 21.1711C20.317 19.7869 23.8057 14.4865 22.5275 9.33238C21.2493 4.17823 15.6883 1.12211 10.1066 2.50633C4.52486 3.89056 1.03618 9.19096 2.31438 14.3451C3.59257 19.4992 9.15361 22.5554 14.7353 21.1711Z",
    fill: "#FBF9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15222 12.3855C8.15222 11.6077 7.62841 11.1738 6.94058 11.1738C6.32682 11.1738 5.66016 11.8405 5.66016 12.3855C5.66016 12.9093 5.81889 13.0363 6.11518 13.0363H7.51809C7.70328 13.0363 8.15222 12.8943 8.15222 12.3855ZM17.0895 12.3855C17.0895 11.6077 17.6133 11.1738 18.3012 11.1738C18.9149 11.1738 19.5816 11.8405 19.5816 12.3855C19.5816 12.9093 19.4229 13.0363 19.1266 13.0363H17.7236C17.5384 13.0363 17.0895 12.8943 17.0895 12.3855ZM13.7553 13.3114C13.7553 13.8193 13.3003 14.4225 12.5172 14.4225C11.6918 14.4225 11.258 13.6923 11.258 13.3114C11.258 12.9304 11.0675 12.8934 10.8876 12.8934C10.736 12.8529 10.4856 12.9347 10.5279 13.5865C10.5808 14.4013 11.459 15.2373 12.6971 15.2373C14.0728 15.2373 14.5807 13.7982 14.5807 13.3114C14.5807 13.0363 14.3585 12.8934 14.1733 12.8934C13.9881 12.8934 13.7553 12.9939 13.7553 13.3114Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_22980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoondreamLogo);
export default __webpack_public_path__ + "static/media/Moondream_logo.fab9b8367036bd8ac1ce22ffaa550f49.svg";
export { ForwardRef as ReactComponent };